<div class="container-fluid p-0">
  <div class="row">
    <div class="col-md-12">
      <div class="w-100">
        <div class="row mb-xl-3 justify-content-between">
          <div class="col-auto">
            <h3 class="page-title">Cases</h3>
          </div>
        </div>
        <div class="card flex-fill border-0">
          <div class="card-header rounded px-4 pb-0 bg-white">
            <div class="row mb-2">
              <div class="col-5"></div>
              <div class="col-2 position-relative">
                <input
                type="text"
                class="form-control"
                placeholder="All Case Types"
                [ngbTypeahead]="searchCaseType"
                [resultTemplate]="rt"
                [inputFormatter]="caseTypeFormatter"
                (blur)="allCaseTypeLoader = false"
                [(ngModel)]="selectedCaseType"
              />
              <div *ngIf="allCaseTypeLoader" class="preloader"></div>
              <ng-template #rt let-r="result" let-t="term">
                <div [term]="t" (click)="selectAllCaseType(r)">
                  {{ r.name }}
                </div>
              </ng-template>
              </div>
              <div class="col-2">
                <select class="form-control">
                  <option value="" selected disabled>All Case Status</option>
                </select>
              </div>
              <div class="col-1">
                <select class="form-control" [formControl]="searchByValue">
                  <option value="" selected disabled>Search By</option>
                  <option value="subject">Subject</option>
                  <option value="client">Client</option>
                  <option value="case_number">Case No.</option>
                </select>
              </div>
              <div class="col-2">
                <input type="text" class="form-control" placeholder="Search" [formControl]="searchCaseText" (keyup.enter)="onEnterPressed()"/>
              </div>
            </div>
            <div class="table-row" *blockUI="'case-list-ui'">
              <table class="table spear-search-table-header-background">
                <thead>
                  <tr>
                    <ng-container *ngFor="let column of caseColumns;let i = index">
                      <th class="border-top-0" scope="col" (click)="sortColumn(column.key)">
                        {{ column.name }}
                        <app-table-column-sort
                          [columnName]="column.key"
                          [orderBy]="caseListOrderBy"
                          [orderDirection]="caseListOrderDirection"
                        ></app-table-column-sort>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody *ngIf="cases?.length">
                  <tr *ngFor="let case of cases">
                    <td>
                      <a target="_blank" class="primary-text font-weight-semibold" [href]="['/limos-case/'+case.id]">
                        {{ case.case_number }}
                      </a>
                    </td>
                    <td>{{ case.case_status }}</td>
                    <td>{{ case.client.name }}</td>
                    <td>{{ case.case_type.name }}</td>
                    <td>{{ case.case_flags?.length ? getNames(case.case_flags) : '' }}</td>
                    <td>{{ case.due_date | date: clientDateFormat }}</td>
                    <td>{{ case.created_at | date: clientDateFormat }}</td>
                    <td>{{ case.modified_at | date: clientDateFormat }}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="!cases?.length">
                  <tr class="bg-white">
                    <td colspan="8" class="text-center">Data not available</td>
                  </tr>
                </tbody>
              </table>
              <div class="px-0 py-0 paginationWrapper d-flex" *ngIf="!(!cases || cases.length === 0)">
                <ngb-pagination [(collectionSize)]="caseTotal" [(page)]="casePage" [pageSize]="caseLimit"
                  [maxSize]="10" [boundaryLinks]="true" (pageChange)="onPageChangeCases($event)">
                </ngb-pagination>
                <div class="selected d-flex align-items-center">
                  <select (change)="onSizeChangeCases(caseLimit)" class="custom-select table-select h-100"
                    [(ngModel)]="caseLimit">
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="75">75</option>
                    <option [ngValue]="100">100</option>
                  </select>
                  <p class="mb-0 ml-2 text-nowrap">
                    Showing {{ casePage * caseLimit - caseLimit + 1 }}
                    -
                    {{
                      casePage * caseLimit > caseTotal
                    ? caseTotal
                    : casePage * caseLimit
                    }}
                    of {{ caseTotal }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>